'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _reactCsv = require('react-csv');

var _formatting = require('../../utils/formatting');

var _currencies = require('../../utils/currencies');

var _emvUtils = require('../../utils/emv-utils');

var _roiReport = require('../roi-report');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tableStyle = { marginBottom: 0 };
var boldFontStyle = { fontWeight: 'bold' };
var avatarStyle = {
  width: 50,
  height: 50,
  float: 'left'
};

var influencerNameStyle = {
  fontSize: 16,
  marginLeft: 8,
  marginBottom: -4,
  marginTop: 4,
  float: 'left'
};

var influnecerHandleStyle = {
  marginLeft: 8,
  marginTop: 3,
  float: 'left',
  color: 'gray'
};

var HELP_LINK = 'https://help.dyzio.co/campaign-reports/roi-report';
var goToHelpPage = function goToHelpPage() {
  return window.open(HELP_LINK, '_blank');
};

var hostname = _lodash2.default.toLower(window.location.hostname);
var isVoxogram = hostname.match(/voxogram/);

var TotalsRow = function TotalsRow(_ref) {
  var rows = _ref.rows,
      currency = _ref.currency;

  var _getTotals = (0, _emvUtils.getTotals)(rows, true),
      reachTotal = _getTotals.reachTotal,
      impressionsTotal = _getTotals.impressionsTotal,
      engagementsTotal = _getTotals.engagementsTotal,
      videoViewsTotal = _getTotals.videoViewsTotal,
      impsEMVTotal = _getTotals.impsEMVTotal,
      engsEMVTotal = _getTotals.engsEMVTotal;

  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    { textAlign: 'center', style: boldFontStyle },
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      _react2.default.createElement(
        'b',
        null,
        'Totals'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(reachTotal)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(impressionsTotal)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(videoViewsTotal)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(engagementsTotal)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      impsEMVTotal ? (0, _currencies.renderCurrency)(currency) + ' ' + (0, _formatting.priceFormatted)(impsEMVTotal) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _currencies.renderCurrency)(currency),
      ' ',
      (0, _formatting.priceFormatted)(engsEMVTotal)
    )
  );
};

var twoRowsModeArrowStyle = {
  color: 'gray',
  display: 'block',
  float: 'right',
  marginLeft: -22,
  marginTop: -3,
  marginRight: -10
};

var oneRowModeArrowStyle = (0, _extends3.default)({}, twoRowsModeArrowStyle, {
  marginTop: 3
});

var SortArrow = function SortArrow(_ref2) {
  var field = _ref2.field,
      order = _ref2.order,
      targetField = _ref2.targetField,
      twoRowsMode = _ref2.twoRowsMode;

  var shouldRenderIcon = _lodash2.default.eq(field, targetField);
  if (shouldRenderIcon) {
    return _react2.default.createElement(_semanticUiReact.Icon, {
      name: 'angle ' + (order === 'asc' ? 'up' : 'down'),
      style: twoRowsMode ? twoRowsModeArrowStyle : oneRowModeArrowStyle,
      size: 'small'
    });
  }
  return null;
};

SortArrow.propTypes = {
  field: _propTypes2.default.string.isRequired,
  order: _propTypes2.default.oneOf(['asc', 'desc']).isRequired,
  targetField: _propTypes2.default.string.isRequired,
  twoRowsMode: _propTypes2.default.boolean
};

SortArrow.defaultProps = {
  twoRowsMode: false
};

var ReportTableHeader = function ReportTableHeader(_ref3) {
  var onSortChanged = _ref3.onSortChanged,
      sort = _ref3.sort;
  return _react2.default.createElement(
    _semanticUiReact.Table.Header,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('name');
        }
      },
      'influencer ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ targetField: 'name' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('trackedAssetsStats.totalAssets');
        }
      },
      'assets ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ targetField: 'trackedAssetsStats.totalAssets' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.reach');
        },
        textAlign: 'center'
      },
      'total ',
      _react2.default.createElement('br', null),
      'reach ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.reach' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.impressions');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'total ',
          _react2.default.createElement('br', null),
          'imps',
          _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.impressions' }, sort))
        ),
        content: 'total impressions'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.videoViews');
        },
        textAlign: 'center'
      },
      'video ',
      _react2.default.createElement('br', null),
      'views ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.videoViews' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.engagements');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'total ',
          _react2.default.createElement('br', null),
          'engs ',
          _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.engagements' }, sort))
        ),
        content: _react2.default.createElement(
          'span',
          null,
          'total engagements:',
          _react2.default.createElement('br', null),
          ' likes + comments'
        )
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('emv.reachCPM');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'impressions',
          _react2.default.createElement('br', null),
          'EMV',
          _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'emv.impressionsEMV' }, sort))
        ),
        content: 'impressions EMV'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('emv.impressionsCPM');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'engagements ',
          _react2.default.createElement('br', null),
          'EMV',
          _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'emv.engagementsEMV' }, sort))
        ),
        content: 'engagements EMV'
      })
    )
  );
};

ReportTableHeader.propTypes = {
  onSortChanged: _propTypes2.default.func.isRequired
};

var EstimatedImpresssions = function EstimatedImpresssions(_ref4) {
  var text = _ref4.text,
      currency = _ref4.currency,
      value = _ref4.value,
      _ref4$formattingMetho = _ref4.formattingMethod,
      formattingMethod = _ref4$formattingMetho === undefined ? _formatting.commaFormatted : _ref4$formattingMetho;

  var style = { color: 'orange' };
  if (value === 0) return _react2.default.createElement(
    'span',
    null,
    '-'
  );
  return _react2.default.createElement(_semanticUiReact.Popup, {
    trigger: _react2.default.createElement(
      'span',
      { style: style },
      currency ? (0, _currencies.renderCurrency)(currency) : '',
      ' ',
      formattingMethod(value)
    ), content: text
  });
};

EstimatedImpresssions.defaultProps = {
  text: 'This is an estimated value.'
};

var ReportRow = function ReportRow(_ref5) {
  var id = _ref5.id,
      name = _ref5.name,
      thumbnail = _ref5.thumbnail,
      influencerName = _ref5.influencerName,
      collaborationId = _ref5.collaborationId,
      currency = _ref5.currency,
      _ref5$totals = _ref5.totals,
      reach = _ref5$totals.reach,
      impressions = _ref5$totals.impressions,
      engagements = _ref5$totals.engagements,
      videoViews = _ref5$totals.videoViews,
      _ref5$emv = _ref5.emv,
      estimatedImpressionsEMV = _ref5$emv.estimatedImpressionsEMV,
      estimatedImpressions = _ref5$emv.estimatedImpressions,
      eImpressionsCPM = _ref5$emv.impressionsCPM,
      eEngagementsCMP = _ref5$emv.engagementsCPM,
      impressionsEMV = _ref5$emv.impressionsEMV,
      engagementsEMV = _ref5$emv.engagementsEMV,
      trackedAssetsStats = _ref5.trackedAssetsStats;
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    { key: id },
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Image, {
        src: thumbnail,
        className: 'circular',
        style: avatarStyle
      }),
      _react2.default.createElement(
        'a',
        { target: '_blank', href: 'https://share.dyzio.co/collab/' + collaborationId + '/campaign', title: 'Click here to view ' + influencerName + '\'s content' },
        _react2.default.createElement(
          'span',
          { style: influencerNameStyle },
          influencerName
        )
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'span',
        { style: influnecerHandleStyle },
        name
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_roiReport.RowAssets, trackedAssetsStats)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      reach ? (0, _formatting.commaFormatted)(reach) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      impressions ? (0, _formatting.commaFormatted)(impressions) : _react2.default.createElement(EstimatedImpresssions, { text: 'This is an estimated value. (Engagements * I/E Ratio)', value: estimatedImpressions })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      videoViews ? (0, _formatting.commaFormatted)(videoViews) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      engagements ? (0, _formatting.commaFormatted)(engagements) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      impressionsEMV ? (0, _currencies.renderCurrency)(currency) + ' ' + (0, _formatting.priceFormatted)(impressionsEMV) : _react2.default.createElement(EstimatedImpresssions, {
        value: estimatedImpressionsEMV,
        formattingMethod: _formatting.priceFormatted,
        currency: currency
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      engagementsEMV ? (0, _currencies.renderCurrency)(currency) + ' ' + (0, _formatting.priceFormatted)(engagementsEMV) : '-'
    )
  );
};

ReportRow.propTypes = {
  id: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  budget: _propTypes2.default.any.isRequired,
  currency: _propTypes2.default.string.isRequired,
  totals: _propTypes2.default.object.isRequired,
  costs: _propTypes2.default.object.isRequired,
  trackedAssetsStats: _propTypes2.default.object.isRequired,
  thumbnail: _propTypes2.default.string.isRequired,
  influencerName: _propTypes2.default.string.isRequired,
  emv: _propTypes2.default.object
};

var reverseOrder = function reverseOrder() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'asc';

  if (order === 'asc') {
    return 'desc';
  }
  return 'asc';
};

var EMVReport = function (_Component) {
  (0, _inherits3.default)(EMVReport, _Component);

  function EMVReport(props) {
    (0, _classCallCheck3.default)(this, EMVReport);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EMVReport.__proto__ || (0, _getPrototypeOf2.default)(EMVReport)).call(this, props));

    _this.onSortFieldChange = function (field) {
      _this.setState({
        sort: {
          field: field,
          order: reverseOrder(_this.state.sort.order)
        }
      });
    };

    _this.state = {
      sort: {
        field: 'totals.reach',
        order: 'desc'
      }
    };
    return _this;
  }

  (0, _createClass3.default)(EMVReport, [{
    key: 'render',
    value: function render() {
      var sort = this.state.sort;
      var _props = this.props,
          campaignName = _props.campaignName,
          currency = _props.currency,
          emv = _props.emv,
          reportData = _props.reportData,
          onFilterChange = _props.onFilterChange,
          filter = _props.filter;

      var isEmptyReport = _lodash2.default.isEmpty(reportData);

      var reportRows = reportData;
      var isFiltered = false;

      if (_lodash2.default.get(filter, 'basic.handle', false)) {
        isFiltered = true;
        reportRows = _lodash2.default.filter(reportRows, ['name', _lodash2.default.get(filter, 'basic.handle')]);
      }

      var csvValues = _lodash2.default.map(reportRows, function (item) {
        return {
          name: item.name,
          reach: item.totals.reach,
          impressions: item.totals.impressions,
          engagements: item.totals.engagements,
          videoViews: item.totals.videoViews,
          impressionsCPM: item.emv.impressionsCPM,
          engagementsCPM: item.emv.engagementsCPM,
          impressionsEMV: item.emv.impressionsEMV,
          engagementsEMV: item.emv.engagementsEMV
        };
      });

      var timestamp = (0, _moment2.default)().format('YYYY-MM-DD');
      var influencerNames = _lodash2.default.map(reportData, 'name');
      var csvFileName = _lodash2.default.kebabCase(campaignName) + '-emv-' + timestamp + '.csv';

      var sortedReportRows = _lodash2.default.orderBy(reportRows, [sort.field], [sort.order]);

      var totals = (0, _emvUtils.getTotals)(reportRows, true);

      var totalItems = [{ key: 'views', label: 'Views', value: (0, _formatting.paidReportFormat)(totals.videoViewsTotal) }, { key: 'reach', label: 'Reach', value: (0, _formatting.paidReportFormat)(totals.reachTotal) }, { key: 'impressions', label: 'Impressions', value: (0, _formatting.paidReportFormat)(totals.impressionsTotal) }, { key: 'engagements', label: 'Engagements', value: (0, _formatting.paidReportFormat)(totals.engagementsTotal) }, { key: 'impressions', label: 'Impressions', value: (0, _formatting.paidReportFormat)(totals.impressionsTotal) }, {
        color: 'pink',
        key: 'impsEMVTotal',
        label: 'Impressions EMV',
        value: (0, _currencies.renderCurrency)(currency) + ' ' + (0, _formatting.emvTotalPriceFormatted)(totals.impsEMVTotal)
      }, {
        color: 'pink',
        key: 'engsEMVTotal',
        label: 'Engagements EMV',
        value: (0, _currencies.renderCurrency)(currency) + ' ' + (0, _formatting.emvTotalPriceFormatted)(totals.engsEMVTotal)
      }];

      var hasMissingEMVValues = _lodash2.default.some(_lodash2.default.values(emv), function (value) {
        return _lodash2.default.isNil(value);
      });

      return _react2.default.createElement(
        'div',
        null,
        isEmptyReport && _react2.default.createElement(_semanticUiReact.Message, null),
        !isEmptyReport && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _semanticUiReact.Segment,
            null,
            _react2.default.createElement(_semanticUiReact.Statistic.Group, { size: 'tiny', widths: 'six', items: totalItems })
          ),
          _react2.default.createElement(
            _semanticUiReact.Menu,
            null,
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'FILTER BY:'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dropdown,
                { scrolling: true, item: true, text: isFiltered ? filter.basic.handle : 'influencer' },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  isFiltered && _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    {
                      onClick: function onClick(event) {
                        return onFilterChange(event, { value: 'handle.reset' });
                      },
                      value: 'discussion.reset'
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
                    'reset'
                  ),
                  _lodash2.default.map(influencerNames, function (name) {
                    return _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        onClick: function onClick(event) {
                          return onFilterChange(event, { value: 'handle.' + name });
                        },
                        value: 'discussion'
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', size: 'tiny' }),
                      ' ',
                      _lodash2.default.toLower(name)
                    );
                  })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              { position: 'right' },
              _react2.default.createElement(
                _semanticUiReact.Label,
                { basic: true, size: 'large', color: 'pink' },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
                _react2.default.createElement(
                  _reactCsv.CSVLink,
                  { data: csvValues, filename: csvFileName },
                  'Download Report'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              null,
              !isVoxogram && _react2.default.createElement(_semanticUiReact.Button, { color: 'pink', inverted: true, size: 'tiny', circular: true, icon: 'help', onClick: goToHelpPage })
            )
          ),
          hasMissingEMVValues && _react2.default.createElement(_semanticUiReact.Message, {
            warning: true,
            icon: 'ban',
            header: 'Report setup incomplete',
            content: 'Please provide impressions CPM, engagements CPM, I/E Ratio. These values are added on the Settings tab.'
          }),
          _react2.default.createElement(
            _semanticUiReact.Card,
            { fluid: true, color: 'green' },
            _react2.default.createElement(
              _semanticUiReact.Table,
              { sortable: true, basic: 'very', singleLine: true, celled: true, style: tableStyle },
              _react2.default.createElement(ReportTableHeader, {
                onSortChanged: this.onSortFieldChange,
                sort: sort
              }),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _lodash2.default.map(sortedReportRows, function (row) {
                  console.log(row);return _react2.default.createElement(ReportRow, (0, _extends3.default)({ key: (0, _uuid2.default)() }, row, { currency: currency }));
                }),
                _react2.default.createElement(TotalsRow, { currency: currency, rows: reportRows })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Card.Content,
              { extra: true },
              _react2.default.createElement(
                'div',
                { className: 'ui right aligned' },
                'Report generated at ',
                _react2.default.createElement(
                  'strong',
                  null,
                  (0, _moment2.default)().format('MMMM Do YYYY, h:mm a')
                ),
                '.'
              )
            )
          )
        )
      );
    }
  }]);
  return EMVReport;
}(_react.Component);

EMVReport.propTypes = {
  onFilterChange: _propTypes2.default.func,
  campaignName: _propTypes2.default.string.isRequired,
  currency: _propTypes2.default.string.isRequired,
  filter: _propTypes2.default.object.isRequired,
  reportData: _propTypes2.default.object.isRequired
};

EMVReport.defaultProps = {
  onFilterChange: _lodash2.default.noop
};

exports.default = EMVReport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/emv-report/index.js
// module id = 2184
// module chunks = 1